import React, { useEffect } from "react";
import Navbar from "../../shared/Navbar/Navbar";
import Footer from "../../shared/Footer/Footer";
import "../../../style/projects/bbcMedia.css";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const BBCMediaAction = () => {
  useEffect(() => {
    document.title = `AshroyAngon | BBC Media Action`;
  }, []);

  const shareUrl = "https://ashroyangon.org/projects/bbc-media-action";

  return (
    <div>
      <Navbar />
      <TranslateButton />

      <div className="bbc_media_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2> BBC Media Action </h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="container">
          <h3>Freedom of Expression for Effective Democracy in Bangladesh</h3>
          <div className="table_wrapper">
            <table>
              <thead>
                <tr>
                  <th>SL No</th>
                  <th>Name of Content</th>
                  <th colSpan={4}>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Project Name</td>
                  <td colSpan={4}>
                    Freedom of Expression for Effective Democracy in Bangladesh
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Name of Donor</td>
                  <td colSpan={4}>European Commission</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Total Budget:</td>
                  <td colSpan={4}>BDT 3,035,890/-</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Duration</td>
                  <td>Date Started</td>
                  <td>May 2026</td>
                  <td>Date End</td>
                  <td>Continue</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Total Beneficiary</td>
                  <td colSpan={4}>1000 Youth</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Project Location</td>
                  <td colSpan={4}>Rangamati Sadar, Rangamamti Hill District</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Main Objectives</td>
                  <td colSpan={4}>
                    The project aims to enhance the media literacy, digital skills, and awareness of freedom of expression among youth, minority, and marginalized communities in Rangamati. Through community-based training and discussion sessions, participants will be empowered to access and use information safely, responsibly, and effectively.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BBCMediaAction;
